export enum TransactionReason {
  CUSTOMER_UNSATISFIED = 'CUSTOMER_UNSATISFIED',
  PROMOTION = 'PROMOTION',
  ERROR = 'ERROR',
  OTHER = 'OTHER',
}
